export const SMS_OPT_IN_ALLOWED_EMAIL_TYPES = [
  "Friday Ongoing Emails Only",
  "Friday Ongoing Emails Only - Registered Members Only",
  "Monthly Kick Off Email Only",
  "Ongoing Emails",
  "Ongoing Emails - Registered Members Only",
  "User-Driven Emails Only",
  "Wednesday Ongoing Emails Only",
  "Wednesday Ongoing Emails Only - Registered Members Only",
];

export const SKIP_SMS_OPT_IN_EMAIL_TYPES = [
  "Client Sends",
  "Not Sending Emails",
  "Welcome Series Only",
];
